module.exports = __webpack_public_path__ + "static/img/5.12c0347.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/14/eng/5.png
// module id = TEKH
// module chunks = 0